const loader = {
  state: {
    loaderCount: 0
  },
  getters: {
    loaderCount: state => state.loaderCount
  },
  mutations: {
    addLoader: state => state.loaderCount++,
    removeLoader: state => state.loaderCount--
  }
}

export default loader
